var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8787 12.4968C13.7101 12.6592 13.4847 12.75 13.2501 12.75C13.0155 12.75 12.7901 12.6592 12.6215 12.4968C11.0772 11.0004 9.00759 9.32877 10.0169 6.90187C10.5626 5.58966 11.8725 4.75 13.2501 4.75C14.6277 4.75 15.9376 5.58966 16.4833 6.90187C17.4913 9.32571 15.4268 11.0055 13.8787 12.4968Z",
    stroke: "#D6A600",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 8.25H13.259",
    stroke: "#D6A600",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 10.75C20.75 16.2728 16.2728 20.75 10.75 20.75C5.22715 20.75 0.75 16.2728 0.75 10.75C0.75 5.22715 5.22715 0.75 10.75 0.75C16.2728 0.75 20.75 5.22715 20.75 10.75Z",
    stroke: "#D6A600",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13.75L3.75 17.75M13.75 19.75L1.75 7.75",
    stroke: "#D6A600",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapCircle);
export default __webpack_public_path__ + "static/media/map-circle.65289fa10a0303254661deab8cc6a4c8.svg";
export { ForwardRef as ReactComponent };